import api from '../api';

export async function getBrands() {
  return api.get('/tienda/marcas/');
}
